<template>
    <label class="c-form_label">
        <slot></slot>
    </label>
</template>


<script>

export default {
    name: 'FormLabel'
}

</script>


<style lang="scss">

.c-form_label {
    font-size: 1rem;
    display: block;
    margin-bottom: 3px;
}

</style>
